import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
// import useQlikApp from 'hooks/useQlikApp';
import useQlikSessionObject from 'hooks/useQlikSessionObject';
import numeral from 'numeral';
import useStyles from './styles';

import TranslationTxt from '../TranslationTxt/TranslationTxt';

import AppContext from '../../AppContext';

const KpiSection = ({ header, text }) => {
  const classes = useStyles();

  // const qlikApp = useQlikApp();
  const { qlikApp } = useContext(AppContext);

  const dataOptions = useQlikSessionObject({
    app: qlikApp,
    properties: {
      qHyperCubeDef: {
        qDimensions: [],
        qMeasures: [
          {
            qDef: {
              // qDef: 'Count({<[Name of media outlet completing the survey - 2023]=, [Name of media outlet for search - 2023]=, [Race - 2023]=>} [Name of media outlet completing the survey - 2023])',
              qDef: 'Sum(273)',
            },
          },
          {
            qDef: {
              // qDef: 'Sum({<[Name of media outlet completing the survey - 2023]=, [Name of media outlet for search - 2023]=, [Race - 2023]=>}[Number of Employees - 2023])',
              qDef: '=Sum(6035)',
            },
          },
          {
            qDef: {
              qDef: 'Sum({<[Gender - 2023]={Women}, [Name of media outlet completing the survey - 2023]=, [Race - 2023]=-{"Unknown"}, [Name of media outlet for search - 2023]=>} [Number of Employees - 2023])/Sum({<[Name of media outlet completing the survey - 2023]=, [Name of media outlet for search - 2023]=, [Race - 2023]=-{"Unknown"}>} [Number of Employees - 2023])',
              qNumFormat: {
                qType: 'I',
                qnDec: 2,
                qUseThou: 0,
                qFmt: '##%',
                qDec: '.',
              },
            },
          },
          {
            qDef: {
              qDef: 'Sum({<[Race - 2023]={White}, [Unknown Flag - 2023]={0}, [Name of media outlet completing the survey - 2023]=, [Name of media outlet for search - 2023]=>} [Number of Employees - 2023])/Sum({<[Unknown Flag - 2023]={0}, [Name of media outlet completing the survey - 2023]=, [Name of media outlet for search - 2023]=, [Race - 2023]=>} [Number of Employees - 2023])', // remove unknown
              qNumFormat: {
                qType: 'I',
                qnDec: 2,
                qUseThou: 0,
                qFmt: '##%',
                qDec: '.',
              },
            },
          },
        ],
      },
    },
  });

  const _kpis = useMemo(() => {
    if (!dataOptions.layout) return [];
    return dataOptions.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => [
      {
        text: '=Only({<Index = {7}>}[$(vLanguage)])',
        number: row[0].qText,
      },
      {
        text: '=Only({<Index = {8}>}[$(vLanguage)])',
        number: numeral(row[1].qText).format('0,0'),
      },
      {
        text: '=Only({<Index = {9}>}[$(vLanguage)])',
        number: row[2].qText,
      },
      {
        text: '=Only({<Index = {20}>}[$(vLanguage)])',
        number: row[3].qText,
      },
    ])[0];
  }, [dataOptions.layout]);

  return (
    <div className="section" style={{ marginBottom: 50, marginTop: 50 }}>
      <Typography variant="h3" className={classes.header}>
        <TranslationTxt measure={header} />
      </Typography>
      <Typography variant="body1" className={classes.text}>
        <TranslationTxt measure={text} />
      </Typography>
      <Box className={classes.KpiWrapper}>
        {
          _kpis.map((kpi) => (
            <Box className={classes.kpi} key={kpi.text}>
              <Typography variant="body2" className={classes.kpiNumber} dangerouslySetInnerHTML={{ __html: kpi.number.includes('%') ? `${kpi.number.slice(0, -1)}<span style="font-size: 40px; position: relative; top: -8px;">%</span>` : kpi.number }} />
              <Typography variant="body2" className={classes.kpiText}>
                <TranslationTxt measure={kpi.text} />
              </Typography>
            </Box>
          ))
        }
      </Box>
    </div>
  );
};

KpiSection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

KpiSection.defaultProps = {
  header: '',
  text: '',
};

export default KpiSection;
